import { render, staticRenderFns } from "./TTag.vue?vue&type=template&id=ab1d8fd4&scoped=true&"
import script from "./TTag.vue?vue&type=script&lang=js&"
export * from "./TTag.vue?vue&type=script&lang=js&"
import style0 from "./TTag.vue?vue&type=style&index=0&id=ab1d8fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1d8fd4",
  null
  
)

/* custom blocks */
import block0 from "./TTag.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports